import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { ConfigurationPageTemplate } from "@/pages/IntegrationsPage/components/templates/ConfigurationPageTemplate"
import { PackageRegistryConfigurationTab } from "./PackageRegistryConfigurationTab"

export const PackageRegistryConfigurationPage = () => {
  const vendor = INTEGRATION_VENDORS.packageRegistry

  return (
    <ConfigurationPageTemplate
      vendor={vendor}
      config={<PackageRegistryConfigurationTab vendor={vendor} />}
      titleKey="integrations.packageRegistry.configuration.title"
    />
  )
}
